import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useStaticQuery, graphql } from 'gatsby'
import Image from '../../../components/image'
import { ContactBannerWrap } from './banner-area.stc'

const BannerArea = () => {
	const contactBannerData = useStaticQuery(graphql`
        query ContactBannerQuery {
            contactJson(jsonId: {eq: "contact-page-banner"}) {
				banner {
					childImageSharp {
						gatsbyImageData(width: 1260, height: 585, layout: CONSTRAINED, quality: 100, placeholder: TRACED_SVG)
					}
				}
            }
        }      
    `);

	return (
		<ContactBannerWrap>
			<Container>
				<Row>
					<Col lg={12}>
						<Image src={contactBannerData.contactJson.banner} alt="about banner" />
					</Col>
				</Row>
			</Container>
		</ContactBannerWrap>
	)
}

export default BannerArea
